import React, { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Link } from "react-router-dom";
import calls from "apis/calls";
function SecretRecoveryPhase() {
  const [password, setPassword] = useState("");

  const [copy, setCopy] = useState(false);
  const [words, setwords] = useState([]);
  // const [keyForCopy, setKeyForCopy] = useState([]);
  // console.log(words);
  // console.log(keyForCopy);
  const onCopyText = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 2000);
  };
  console.log(words);
  const show = async () => {
    // console.log(await calls.getSecretphrase());
  };
  show();
  useEffect(async () => {
    const password = JSON.parse(localStorage.getItem("password"));
    if (password) {
      setPassword(password);
    }
    calls.generateWallet();
    const phrase = await calls.getSecretphrase();
    const phraseArr = phrase.split(" ");
    setwords(phraseArr);
    // setKeyForCopy(phraseArr);
    // console.log(phrase, phraseArr);
  }, []);
  return (
    <div>
      <div className="bg-img-main">
        <div className="bg-img"></div>
      </div>

      {/* ========================Home-Banner===================  */}
      <section id="banner">
        <div className="custom-container">
          <div className="sec-padding">
            <div className="row">
              <div className="col-lg-12">
                <div className="main">
                  <div className="box">
                    <div className="heading">
                      <h2>Write Down Your Secret Recovery Phase</h2>
                    </div>
                    <div className="para">
                      import an existing wallet or create a new Lorem ipsum,
                      dolor sit amet consectetur adipisicing elit. Ullam
                      laudantium accusantium officia? Maiores, voluptatem
                      accusantium. Nesciunt harum ullam quidem iusto eum aperiam
                      accusantium nisi, eaque odio quam deleniti magni ad?
                    </div>
                  </div>
                  <div className="recovery-box">
                    <div className="row">
                      {words.map((item, ind) => (
                        <div className="col-sm-6" key={ind}>
                          <span>
                            <input
                              type="text"
                              value={item}
                              readOnly
                              // onChange={(event) =>
                              //   setKeyForCopy(event.target.value)
                              // }
                            />
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <CopyToClipboard text={words} onCopy={onCopyText}>
                    <button>Copy to clipboard</button>
                  </CopyToClipboard>
                  {copy ? <span style={{ color: "red" }}>Copied.</span> : null}
                  <div className="send-btn mt-5">
                    <Link to="/enter-recovery-phase">
                      <button type="submit" className="btn w-100">
                        <span> Next</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SecretRecoveryPhase;
